import { getWorksiteInfo } from "../lib/utilities";
import { useContext } from "react";
import CountryContext from "../../../CountryContext";
import { FormattedMessage, useIntl } from "react-intl";
import { ClipboardIcon } from "@heroicons/react/20/solid";
import Placeholder from "@ui-components/Placeholder";
import { WorksiteInfoProps } from "../types";
import { NotificationsContext } from "@ui-components/Notifications";
import AuthenticationService from "@services/AuthenticationService";

export const WorksiteInfo = ({ worksite, quotation, agent }: WorksiteInfoProps) => {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const userData = AuthenticationService.getUserData();
  const {
    country: { code },
  } = useContext(CountryContext);
  const showLink = worksite?.r_perm?.includes(`user_${userData.id}`) || worksite?.r_perm?.includes(userData.role_type);
  const info = [
    { key: "agent", value: quotation?.des_agent ||  agent?.name || '-', icon: null },
    ...(getWorksiteInfo(code, worksite, showLink) || []),
    ...(!!quotation?.extended_id
      ? [
          {
            key: "offer_id",
            value: quotation.extended_id,
            icon: (
              <ClipboardIcon
                className="inline w-4 -mt-0.5 text-kerakoll-700 cursor-pointer"
                onClick={() => {
                  navigator.clipboard
                    .writeText(quotation.extended_id)
                    .then(() => {
                      push({
                        type: "info",
                        title: intl.formatMessage({
                          id: "id_copied_in_clipboard",
                        }),
                      });
                    });
                }}
              />
            ),
          },
        ]
      : []),
    ...(!!quotation
      ? [
          {
            key: "status",
            value: intl.formatMessage({ id: quotation.status }),
            icon: null,
          },
        ]
      : []),
  ];
  return (
    <div className="w-full flex flex-col gap-2">
      {!!info.length ? (
        <>
          {info.map(({ key, value, icon }, idx) => (
            <p key={idx}>
              <FormattedMessage id={key} />:{" "}
              <span className="font-semibold">
                <FormattedMessage id={value} />
              </span>
              <span className="ml-1.5">{icon}</span>
            </p>
          ))}
        </>
      ) : (
        ["w-1/3", "w-2/3", "w-1/2", "w-1/2"].map((w, idx) => (
          <Placeholder key={idx} width={w} classNames="max-w-full" />
        ))
      )}
    </div>
  );
};
